import { render, staticRenderFns } from "./viewOverrides.vue?vue&type=template&id=e5723f4e&"
import script from "./viewOverrides.vue?vue&type=script&lang=js&"
export * from "./viewOverrides.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/cjzhi98/chatwoot-saas/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5723f4e')) {
      api.createRecord('e5723f4e', component.options)
    } else {
      api.reload('e5723f4e', component.options)
    }
    module.hot.accept("./viewOverrides.vue?vue&type=template&id=e5723f4e&", function () {
      api.rerender('e5723f4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/routes/dashboard/branches/components/viewOverrides.vue"
export default component.exports